import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
//import TopMenu from './components/TopMenu.tsx';
import App from './App.tsx'
import { setOptions } from '@googlemaps/js-api-loader';
import { Stimulsoft } from 'stimulsoft-reports-js/Scripts/stimulsoft.viewer';
import 'stimulsoft-reports-js/Css/stimulsoft.viewer.office2013.whiteblue.css';


Stimulsoft.Base.StiLicense.key = "6vJhGtLLLz2GNviWmUTrhSqnOItdDwjBylQzQcAOiHlZyes7MY0FF9Lfn91ptW0FhaIixaVqAe5JVM1pjTq9R1l4wf" +
    "HnfQTqrblz5Ti1j4hV3AOtIInmcjD+3tKaR7zes59gqFTbZpoGADNN46BtrRTxXnU8Ikch2AxsuTIOhk90IAbc9qm7" +
    "88R7LINyn1iugKeWG7xriuzepvfCyxyWOMkV3KOnqWWHaNXv9GUSO+B6yI6uJzX/ZWEjPjaRcYdtNXmRyMy7p99FZE" +
    "0vLoJdsx9+OAosQGMoYhBQDMYDGB8pVHKHbR6peDhwHTrtkmpPnFoa5gImowo5UciXyiM6bLjMQoLk4JCYPhO9tKjz" +
    "iGZPUAtN6DvOlPFATu1itaFD0hS1rbGrErZG2vv9NwwL4MDw1Og4cxAThTRzDaZ7B2w5OzWPfe4ONbv+AD0TDJLWMT" +
    "9AQT0DV8JVRBtNeZ9y+jXxWy2ooCkT7CbqLQFU5iKdnxf54VVlGEwngWaKSPozE06tX4ZcLQVHy4xAcsZlIdHzXqGF" +
    "R1OOcgzsgi7TZk10h6gVm1zTwyWMHUMskm6j";

// Initialize configuration once for the entire app
setOptions({
    key: "AIzaSyCQF4SCDPq-k3Vnqhdrz9XAQHwZTsdeTqI",
    v: "weekly",
    // libraries: [] <- DO NOT pass libraries here anymore
});

//Azure Test Site Google API when testing Dash New
//AIzaSyD3pan6HPfcsVzvT4SEjIuGFbmWiB00r-4

//let userClaims = null;

//(async function () {
//    var req = new Request("/bff/user", {
//        headers: new Headers({
//            "X-CSRF": "1",
//        }),
//    });

//    try {
//        var resp = await fetch(req);
//        if (resp.ok) {
//            userClaims = await resp.json();
//            //log("user logged in", userClaims);
//        } else if (resp.status === 401) {
//            window.location.replace("/bff/login");
//            //log("user not logged in");
//        }
//    } catch (e) {
//        //log("error checking user status");
//    }
//})();

//need something like this so I can redirect to login page if user not logged in
//also need some timer to call this as well before the cookie expires
//import { useEffect, useState } from 'react';

//interface User {
//    profile: { name: string; email: string };
//    // other fields
//}

//function App() {
//    const [user, setUser] = useState<User | null>(null);

//    useEffect(() => {
//        fetch('/bff/user')
//            .then((res) => {
//                if (res.ok) return res.json();
//                throw new Error('Unauthorized');
//            })
//            .then((data) => setUser(data))
//            .catch(() => {
//                // Redirect to login or handle unauthenticated state
//                // window.location.href = '/bff/login';
//            });
//    }, []);

//    return <div>{user ? `Welcome, ${user.profile.name}` : 'Please log in'}</div>;
//}

//// Example: TypeScript check function
//const checkSession = async () => {
//    try {
//        const response = await fetch('/bff/user', {
//            method: 'GET',
//            headers: { 'X-Requested-With': 'XMLHttpRequest' } // Important for BFFs
//        });

//        if (response.status === 401) {
//            // Handle session expiration, e.g., redirect to login
//            window.location.href = '/login';
//        }
//    } catch (error) {
//        console.error('Session check failed', error);
//    }
//};

//// Check every 15 minutes (900,000 ms)
//const intervalId = setInterval(checkSession, 15 * 60 * 1000);

//// Check when user returns to tab
//document.addEventListener('visibilitychange', () => {
//    if (document.visibilityState === 'visible') {
//        checkSession();
//    }
//});


createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <BrowserRouter>
            {/*<TopMenu />*/}
            <App />
            <ToastContainer />
        </BrowserRouter>
    </StrictMode>,
);
